/**
 * User role labels and codes supported by our application.
 */

import { i18n } from '@boot/i18n.js';

const ROLES = {
    viewer: i18n.global.t('Viewer'),
    operator: i18n.global.t('Operator'),
    manager: i18n.global.t('Manager'),
    admin: i18n.global.t('Admin')
};

export { ROLES };

export default ROLES;
